import React from "react";
import { Form, FormGroup, Label, Input, Row, Col, Button } from "reactstrap";
import Select from 'react-select';

const AdSettings = ({ adConfig, formDetails, setFormDetails }) => {
    
    if (!adConfig || !adConfig.items) {
        return (
            <p className="text-center text-muted p-4">
                No ad settings configuration is available.
            </p>
        );
    }
    const shouldDisplayField = (fieldConfig) => {
        if (!fieldConfig.conditional) {
            return true; // If no condition, always show the field.
        }

        const { field, value, all } = fieldConfig.conditional;

        const check = (condition) => {
            const currentValue = formDetails[condition.field];
            
            if (Array.isArray(condition.value)) {
                return condition.value.includes(currentValue);
            }
            return currentValue === condition.value;
        };

        // This handles more complex conditions if you ever need them.
        if (all && Array.isArray(all)) {
            return all.every(check);
        }

        // This handles the simple condition we're using for ads.
        if (field) {
            return check(fieldConfig.conditional);
        }

        return true; // Default to showing the field if the condition is malformed.
    };
    
    const getOptionsForTemplate = (fieldConfig) => {
        const currentTemplate = formDetails.template;
        if (fieldConfig?.item_structure?.position?.options) {
            return fieldConfig.item_structure.position.options.filter(opt => opt.template === currentTemplate);
        }
        return [];
    };

    const renderField = (key, fieldConfig) => {
        if (!shouldDisplayField(fieldConfig)) return null;

        const adsData = formDetails.widget_data?.ads_data || {};

        switch (fieldConfig.type) {
            case "text":
            case "textArea":
                return (
                    <Input
                        type={fieldConfig.type}
                        rows="5"
                        value={adsData[key] || ""}
                        onChange={(e) =>
                            setFormDetails((prev) => ({
                                ...prev,
                                widget_data: { ...prev.widget_data, ads_data: { ...adsData, [key]: e.target.value }},
                            }))
                        }
                    />
                );

            case "array":
                const currentArray = adsData[key] || [];
                return (
                    <Col sm={12} className="px-0">
                        {currentArray.map((item, index) => (
                            <div key={index} className="d-block border rounded p-3 mb-3">
                                <Row>
                                    <Col sm="9">
                                        <strong className="d-block mb-2">{`Ad Block ${index + 1}`}</strong>
                                    </Col>
                                    <Col sm="3" className="text-end">
                                        <Button color="danger" outline size="sm" onClick={() => {
                                            const updatedArray = currentArray.filter((_, i) => i !== index);
                                            setFormDetails(prev => ({ ...prev, widget_data: { ...prev.widget_data, ads_data: { ...adsData, [key]: updatedArray }}}));
                                        }}>Delete</Button>
                                    </Col>
                                </Row>
                                <FormGroup>
                                    <Label>Ad Code</Label>
                                    <Input type="textarea" rows="4" value={item.adcode || ''} onChange={(e) => {
                                        const updatedArray = [...currentArray];
                                        updatedArray[index].adcode = e.target.value;
                                        setFormDetails(prev => ({ ...prev, widget_data: { ...prev.widget_data, ads_data: { ...adsData, [key]: updatedArray }}}));
                                    }}/>
                                </FormGroup>
                                <FormGroup>
                                    <Label>Position</Label>
                                    <Select
                                        options={getOptionsForTemplate(fieldConfig)}
                                        value={
                                            getOptionsForTemplate(fieldConfig).find(
                                                (opt) => opt.value === item.position
                                            ) || null
                                        }
                                        placeholder="Select Position"
                                        onChange={(selected) => {
                                            const updatedArray = [...currentArray];
                                            updatedArray[index].position = selected?.value || "";
                                            setFormDetails(prev => ({ ...prev, widget_data: { ...prev.widget_data, ads_data: { ...adsData, [key]: updatedArray }}}));
                                        }}
                                        isClearable
                                    />
                                </FormGroup>
                            </div>
                        ))}
                        <Button color="primary" size="sm" onClick={() => {
                             setFormDetails(prev => ({ ...prev, widget_data: { ...prev.widget_data, ads_data: { ...adsData, [key]: [...currentArray, { adcode: "", position: "" }] }}}));
                        }}>Add Ad Block</Button>
                    </Col>
                );

            default:
                return null;
        }
    };

    return (
        <Form>
            {Object.entries(adConfig.items).map(([key, fieldConfig]) =>
                shouldDisplayField(fieldConfig) ? (
                    <FormGroup key={key}>
                        <Row className="align-items-start">
                            {fieldConfig.label && (
                                <Col sm="3">
                                    <Label className="form-label">{fieldConfig.label}</Label>
                                </Col>
                            )}
                            <Col sm={fieldConfig.label ? "9" : "12"}>
                                {renderField(key, fieldConfig)}
                                {fieldConfig.help_text && <small className="form-text text-muted">{fieldConfig.help_text}</small>}
                            </Col>
                        </Row>
                    </FormGroup>
                ) : null
            )}
        </Form>
    );
};

export default AdSettings;